import { createSlice } from '@reduxjs/toolkit';
import {
  GoldenCard,
  MergedPackageModel,
  MyOrderListModel,
  PurchaseSteps,
  Subscription,
  UserPackageModel
} from '../views/Marketplace/Maeketplace.types';
import {
  getTravelPackages,
  getTravelutionSubscriptions,
  purchasePackage,
  purchaseSubscription,
  getGoldenCard,
  getTravelutionSubscriptionBundle,
  purchaseGoldenCard,
  getGoldenCardStatus,
  purchaseSubscriptionBundle,
  setPurchaseCardStep,
  setOrderId,
  getSuperSalesLicences,
  purchaseSuperSales
} from '../views/Marketplace/Marketplace.actions';
import { buyVirtualOffice } from '../views/Settings/Settings.actions';

export interface MarketplaceSliceType {
  loading: boolean;
  addHubLoading: boolean;
  currencyType: number;
  hubs: MergedPackageModel[];
  subscriptions: MergedPackageModel[];
  userPackage: UserPackageModel | null;
  subscription: Subscription | null;
  goldenCard: GoldenCard[] | null;
  subscriptionBundle: Subscription | null;
  goldenCardStatus: string;
  orderId: number;
  step: PurchaseSteps;
}

const initialState = {
  loading: false,
  addHubLoading: false,
  currencyType: 0,
  hubs: [],
  subscriptions: [],
  goldenCard: [],
  userPackage: null,
  subscription: null,
  subscriptionBundle: null,
  orderId: 0,
  goldenCardStatus: '',
  step: PurchaseSteps.PAYMENT_METHOD
} as MarketplaceSliceType;

const marketplaceSlice = createSlice({
  name: 'withdraw',
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder.addCase(getTravelutionSubscriptions.pending, (state) => {
      state.loading = true;
      state.hubs = [];
    });
    builder.addCase(
      getTravelutionSubscriptions.fulfilled,
      (state, { payload }) => {
        state.loading = false;
        state.subscriptions = payload.hubs;
        //state.userPackages = payload.userPackages;
      }
    );

    builder.addCase(getTravelutionSubscriptions.rejected, (state) => {
      state.loading = false;
      state.hubs = [];
    });

    // TRAVEL PACKAGES
    builder.addCase(getTravelPackages.pending, (state) => {
      state.loading = true;
      state.hubs = [];
    });
    builder.addCase(getTravelPackages.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.hubs = payload.hubs;
      //state.userPackages = payload.userPackages;
    });

    builder.addCase(getTravelPackages.rejected, (state) => {
      state.loading = false;
    });

    builder.addCase(purchasePackage.pending, (state) => {
      state.addHubLoading = true;
    });
    builder.addCase(purchasePackage.fulfilled, (state, { payload }) => {
      state.addHubLoading = false;
      state.orderId = payload;
    });

    builder.addCase(purchasePackage.rejected, (state) => {
      state.addHubLoading = false;
    });

    // SUBSCRIPTION
    builder.addCase(purchaseSubscription.pending, (state) => {
      state.addHubLoading = true;
    });
    builder.addCase(purchaseSubscription.fulfilled, (state, { payload }) => {
      state.addHubLoading = false;
      state.orderId = payload;
    });

    builder.addCase(purchaseSubscription.rejected, (state) => {
      state.addHubLoading = false;
    });

    // GOLDEN CARD
    builder.addCase(getGoldenCardStatus.fulfilled, (state, { payload }) => {
      state.goldenCardStatus = payload;
    });

    builder.addCase(getGoldenCard.fulfilled, (state, { payload }) => {
      state.goldenCard = payload;
    });

    builder.addCase(purchaseGoldenCard.pending, (state) => {
      state.addHubLoading = true;
    });
    builder.addCase(purchaseGoldenCard.fulfilled, (state, { payload }) => {
      state.addHubLoading = false;
      state.orderId = payload;
    });

    builder.addCase(purchaseGoldenCard.rejected, (state) => {
      state.addHubLoading = false;
    });

    //SUBSCRIPTION BUNDLE
    builder.addCase(
      getTravelutionSubscriptionBundle.fulfilled,
      (state, { payload }) => {
        state.subscriptionBundle = payload;
      }
    );

    builder.addCase(purchaseSubscriptionBundle.pending, (state) => {
      state.addHubLoading = true;
    });
    builder.addCase(
      purchaseSubscriptionBundle.fulfilled,
      (state, { payload }) => {
        state.addHubLoading = false;
        state.orderId = payload;
      }
    );

    // SUPER SALES
    builder.addCase(getSuperSalesLicences.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getSuperSalesLicences.fulfilled, (state, { payload }) => {
      console.log(payload);
      state.loading = false;
      state.hubs = payload;
    });

    builder.addCase(getSuperSalesLicences.rejected, (state) => {
      state.loading = false;
    });

    //PURCHASE SUPER SALES
    builder.addCase(purchaseSuperSales.pending, (state) => {
      state.addHubLoading = true;
    });
    builder.addCase(purchaseSuperSales.fulfilled, (state, { payload }) => {
      state.addHubLoading = false;
      state.orderId = payload;
    });

    builder.addCase(purchaseSuperSales.rejected, (state, { payload }) => {
      state.addHubLoading = false;
    });

    // VIRTUAL OFFICE

    builder.addCase(buyVirtualOffice.pending, (state) => {
      state.addHubLoading = true;
    });
    builder.addCase(buyVirtualOffice.fulfilled, (state, { payload }) => {
      state.addHubLoading = false;
      state.orderId = payload;
    });

    builder.addCase(buyVirtualOffice.rejected, (state) => {
      state.addHubLoading = false;
    });

    builder.addCase(purchaseSubscriptionBundle.rejected, (state) => {
      state.addHubLoading = false;
    });

    //PURCHASE CARD STEPS
    builder.addCase(setPurchaseCardStep.fulfilled, (state, { payload }) => {
      state.step = payload;
    });

    //SET ORDER STEP
    builder.addCase(setOrderId.fulfilled, (state, { payload }) => {
      state.orderId = payload;
    });
  }
});

// export const { clearHubs } = marketplaceSlice.actions;

export default marketplaceSlice.reducer;
